<template>
  <div>
    <Button type="primary" @click="openAddModal">新增</Button>

    <Table :columns="columns10" :data="data9" style="margin-top: 12px"> </Table>

    <Modal v-model="modal1" title="新增" width="900" @on-ok="handleAddOk" @on-cancel="handleAddCancel">
      <div>
        <Form :label-width="80">
          <div v-for="item in prizeItems" :key="item.key" style="margin-bottom: 12px">
            <FormItem :label="item.label">
              <div style="display: flex; align-items: center">
                <Input v-model="prizeForm[item.key].giftId" placeholder="输入礼品id"
                  style="width: 220px; margin-right: 10px" />
                <Button type="primary" size="small" @click="openGoodsSearchModal(item.key)" style="margin-right: 10px">
                  查询商品
                </Button>
                <Input v-model="prizeForm[item.key].giftName" placeholder="礼品名称" disabled
                  style="width: 260px; margin-right: 10px" />
                <Input v-model="prizeForm[item.key].giftNum" placeholder="输入礼品数量" style="width: 220px" />
              </div>
            </FormItem>
          </div>
        </Form>
      </div>
    </Modal>

    <GoodsSearchModal :visible.sync="goodsSearchModal" :goodstypeOptions="goodstypeOptions"
      @select-goods="selectGoods" />

    <Modal v-model="detailModal" title="详情" width="1000" :footer-hide="true">
      <div style="display: flex; flex-wrap: wrap">
        <div v-for="item in detailGridData" :key="item.id || item.nindex"
          style="width: 10%; padding: 6px; box-sizing: border-box">
          <Poptip trigger="hover" placement="top">
            <div :style="{
              border: item.user_id ? '2px solid #ed4014' : '2px solid #2d8cf0',
              background: item.nShang && item.nShang !== 'H' ? '#ffec3d' : '',
              borderRadius: '6px',
              height: '44px',
              width: '44px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: '600',
              cursor: 'default',
            }">
              {{ item.nShang }}
            </div>
            <div slot="content" style="min-width: 220px">
              <div>抽取用户：{{ item.user_id || "-" }}</div>
              <div>抽取时间：{{ formatBeijingTime(item.ctime) }}</div>
              <div>抽取位置：{{ item.cindex || "-" }}</div>
            </div>
          </Poptip>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import SingleUpload from "@/components/Upload/singleUpload";
import {
  setYfsConfig, cmsSelYfsList, setYfsEnd, selYfsDel
} from "../../api/machine";
import wawaGameListModal from "./wawaGameListModal.vue";
import GoodsSearchModal from "@/components/GoodsSearchModal.vue";
import { formatOssUrl } from "@/utils";

const OSS = require("ali-oss");
var ossClient = null;
export default {
  components: { SingleUpload, wawaGameListModal, GoodsSearchModal },
  data() {
    return {
      goodstypeOptions: this.$goodsTypeOptions,
      totalDrawCount: 80,
      modal1: false,
      goodsSearchModal: false,
      detailModal: false,
      detailData: [],
      activePrizeKey: "",
      data9: [],
      columns10: [
        {
          title: "套盒id",
          key: "tid",
        },
        {
          title: "总抽数",
          key: "count",
        },
        {
          title: "剩余抽数",
          key: "remainingCount",
        },
        {
          title: "状态",
          key: "status",
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          render: (h, params) => {
            const buttons = [];

            buttons.push(
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.openDetail(params.row);
                    },
                  },
                },
                "详情"
              )
            );

            if (params.row && params.row.status === "未结束") {
              buttons.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.manualEnd(params.row);
                      },
                    },
                  },
                  "手动结束"
                )
              );
            }

            return h("div", buttons);
          },
        },
      ],
      prizeItems: [
        { key: "A", label: "A赏" },
        { key: "B", label: "B赏" },
        { key: "C", label: "C赏" },
        { key: "D", label: "D赏" },
        { key: "E", label: "E赏" },
        { key: "H", label: "H赏" },
        { key: "最终赏", label: "最终赏" },
      ],
      prizeForm: {
        A: { giftId: "", giftName: "", giftNum: "" },
        B: { giftId: "", giftName: "", giftNum: "" },
        C: { giftId: "", giftName: "", giftNum: "" },
        D: { giftId: "", giftName: "", giftNum: "" },
        E: { giftId: "", giftName: "", giftNum: "" },
        H: { giftId: "", giftName: "", giftNum: "" },
        最终赏: { giftId: "", giftName: "", giftNum: "" },
      },
    }
  },
  computed: {
    detailGridData() {
      const list = Array.isArray(this.detailData) ? this.detailData : [];
      return list
        .slice()
        .sort((a, b) => {
          const ai = a && a.nindex != null ? Number(a.nindex) : 0;
          const bi = b && b.nindex != null ? Number(b.nindex) : 0;
          return ai - bi;
        });
    },
  },
  watch: {
    modal1(val) {
      if (val) {
        this.recalcHPrizeNum();
      }
    },
    "prizeForm.A.giftNum"() {
      this.recalcHPrizeNum();
    },
    "prizeForm.B.giftNum"() {
      this.recalcHPrizeNum();
    },
    "prizeForm.C.giftNum"() {
      this.recalcHPrizeNum();
    },
    "prizeForm.D.giftNum"() {
      this.recalcHPrizeNum();
    },
    "prizeForm.E.giftNum"() {
      this.recalcHPrizeNum();
    },
  },
  mounted() {
    this.selmachine();
  },
  methods: {
    openAddModal() {
      const hasRunning = Array.isArray(this.data9)
        ? this.data9.some((item) => item && item.status === "未结束")
        : false;
      if (hasRunning) {
        this.$Message.error("当前有套盒正在运行,手动结束后才能创建新套盒");
        return;
      }
      this.modal1 = true;
    },
    selmachine() {

      cmsSelYfsList({

      }).then((res) => {
        console.log("===" + JSON.stringify(res));

        this.data9 = res.data;
      });
    },

    openDetail(row) {
      selYfsDel({
        tid: row.tid
      }).then((res) => {
        console.log("===" + JSON.stringify(res));
        this.detailData = (res && res.data) || [];
        this.detailModal = true;
      }).catch((err) => {
        console.error(err);
        this.detailData = [];
        this.detailModal = true;
      });
    },
    formatBeijingTime(time) {
      if (!time) {
        return "-";
      }
      const date = new Date(time);
      if (isNaN(date.getTime())) {
        return time;
      }
      return date.toLocaleString("zh-CN", {
        timeZone: "Asia/Shanghai",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
    },
    manualEnd(row) {
      const tid = row && row.tid != null ? String(row.tid) : "";
      this.$Modal.confirm({
        title: "确认",
        content: "确定要手动结束吗？",
        onOk: () => {
          setYfsEnd({
            tid: row.tid
          }).then((res) => {
            //成功后刷新界面
            this.selmachine();

          }).catch((err) => {

          });
        },
      });
    },

    recalcHPrizeNum() {
      const keys = ["A", "B", "C", "D", "E"];
      let used = 0;
      keys.forEach((k) => {
        const v = (this.prizeForm[k] && this.prizeForm[k].giftNum) || "";
        const n = Number(String(v).trim());
        used += isNaN(n) ? 0 : n;
      });
      let remain = this.totalDrawCount - used;
      if (isNaN(remain)) remain = 0;
      if (remain < 0) remain = 0;
      this.prizeForm.H.giftNum = String(remain);
    },

    openGoodsSearchModal(prizeKey) {
      this.activePrizeKey = prizeKey;
      this.goodsSearchModal = true;
    },
    selectGoods(goods) {
      const key = this.activePrizeKey;
      if (!key || !this.prizeForm[key]) {
        this.goodsSearchModal = false;
        return;
      }
      this.prizeForm[key].giftId = goods && goods.id != null ? String(goods.id) : "";
      this.prizeForm[key].giftName = goods && goods.goodsname ? String(goods.goodsname) : "";
      this.goodsSearchModal = false;
      if (goods && goods.goodsname) {
        this.$Message.success("已选择商品：" + goods.goodsname);
      }
    },
    handleAddOk() {
      this.recalcHPrizeNum();
      const requiredKeys = ["A", "B", "C", "D", "E", "H"];
      for (let i = 0; i < requiredKeys.length; i++) {
        const key = requiredKeys[i];
        const item = this.prizeForm[key] || {};
        const giftId = (item.giftId || "").toString().trim();
        const giftNum = (item.giftNum || "").toString().trim();

        if (!giftId || !giftNum) {
          this.$Message.error(key + "赏必填礼品id和数量");
          return;
        }
        if (isNaN(Number(giftId)) || isNaN(Number(giftNum))) {
          this.$Message.error(key + "赏礼品id和数量必须是数字");
          return;
        }
      }

      const config = {};
      Object.keys(this.prizeForm).forEach((key) => {
        const item = this.prizeForm[key] || {};
        const giftIdStr = (item.giftId || "").toString().trim();
        const giftNumStr = (item.giftNum || "").toString().trim();

        if (key === "FINAL") {
          config[key] = {
            giftId: giftIdStr ? Number(giftIdStr) : 0,
            giftNum: giftNumStr ? Number(giftNumStr) : 0,
          };
          return;
        }

        config[key] = {
          giftId: Number(giftIdStr),
          giftNum: Number(giftNumStr),
        };
      });

      setYfsConfig({ config })
        .then(() => {
          console.log("wawayfs submit config:", config);
          this.$Message.success("设置成功");
          this.modal1 = false;
        })
        .catch((err) => {
          console.error(err);
          this.$Message.error("设置失败");
        });
    },
    handleAddCancel() {
      this.modal1 = false;
    },

  },
};
</script>
